module.exports = __webpack_public_path__ + "static/media/performanceClass.92380dc9.png";